export default __webpack_public_path__ + "images/pages/quiz/categories/desktop_hair-35685009ec7b41bb4150d0eee879294a.svg";